import React, { Component } from 'react'
import { func } from 'prop-types'
import { translate } from 'react-i18next'
import { McGameListDatepicker } from './McGameListDatepicker'
import { McGameListInputText } from './McGameListInputText'
import { McGameListCheckbox } from './McGameListCheckbox'

import './McGameListFilters.css'

@translate()
export class McGameListFilters extends Component {
    static propTypes = {
        onChange: func.isRequired
    }
    state = {
        startDate: null,
        endDate: null,
        code: null,
        onlyCompleted: false,
    }

    handleChange = stateChanges => {
        const { onChange } = this.props
        const { startDate, endDate, code, onlyCompleted } = this.state
        const filters = {
            startDate,
            endDate,
            code,
            onlyCompleted,
            ...stateChanges
        }
        this.setState(filters)
        onChange(filters)
    }

    render() {
        const { t } = this.props
        const { startDate, endDate, code, onlyCompleted } = this.state
        return (
            <div className="McGameList-Filters">
                <p>{t('mc.gameList.filters.title')}</p>
                <div className="flex row-left-center">
                    <McGameListDatepicker
                        label={t('mc.gameList.filters.startDate')}
                        value={startDate}
                        onChange={value => this.handleChange({ startDate: value })}
                    />
                    <McGameListDatepicker
                        label={t('mc.gameList.filters.endDate')}
                        value={endDate}
                        onChange={value => this.handleChange({ endDate: value })}
                    />
                    <McGameListInputText
                        label=""
                        value={code}
                        placeholder={t('mc.gameList.filters.searchCode')}
                        onChange={value => this.handleChange({ code: value })}
                    />
                    <McGameListCheckbox
                        label=""
                        text={t('mc.gameList.filters.onlyCompleted')}
                        value={onlyCompleted}
                        onChange={value => this.handleChange({ onlyCompleted: value })}
                    />
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/MC/GameList/Filters/McGameListFilters.js